import { Stack, Typography } from '@mui/material'
import ArrowRightNewSvg from '~/@ui/_sharedSvgs/ui/ArrowRightNew.svg?react'
import { OpportunityAvatar } from './OpportunityAvatar'

type Props = {
  headerText: string
  bodyText: string
  slug: string
  className?: string
  onClick?: () => void
}

export const OpportunityCard = ({
  headerText,
  bodyText,
  slug,
  className = '',
  onClick,
}: Props) => {
  return (
    <Stack
      className={`p-4 rounded-4d bg-zGrey200 cursor-pointer ${className}`}
      onClick={onClick}>
      <Stack className="flex-row items-center gap-4 mb-2">
        <OpportunityAvatar slug={slug} />
        <Typography className="text-lg font-semibold text-zBlack200">
          {headerText}
        </Typography>
      </Stack>

      <Typography className="text-3d font-medium text-zGrey300 pb-2">
        {bodyText}
      </Typography>

      <Stack className="flex-row justify-between items-center pt-3">
        <Typography className="text-3d font-bold text-zBlack200">
          Zistiť viac
        </Typography>
        <ArrowRightNewSvg />
      </Stack>
    </Stack>
  )
}
